import {useState} from "react";
import { HomeSection } from '../../../common/HomeSection.jsx'
import { Icons } from '../../../common/Icons.jsx'
import {AIChatModalContent} from "../../../common/index.js";
import HasRole from "../../../common/authirization/HasRole.jsx";

const ViewReporterHome = () => {
    const [showAIChat, setShowAIChat] = useState(false)

    return (
        <>
            <HomeSection
                title={'Narzędzia'}
                items={[
                    {
                        icon: <Icons.excel size={80} />,
                        title: 'Raporty',
                        text: 'Przeglądaj i generuj raporty z bazy danych',
                        actionLink: '/reporter/raporty',
                        actionText: 'Przejdź do raportów',
                    },
                    {
                        icon: <Icons.aiDb size={80}/>,
                        title: 'Czat z bazą',
                        perms:['ai_raporty_podglad'],
                        text: 'Rozmawiaj z bazą danych',
                        onClick: () => setShowAIChat(true),
                    }
                ]}
            />
            {showAIChat &&
                <HasRole roles={['ai_raporty_podglad']} mode={'all'}>
                    <AIChatModalContent
                        show={showAIChat}
                        handleClose={() => setShowAIChat(false)}
                    />
                </HasRole>
            }
        </>
    )
}

export default ViewReporterHome

